import Layout from '@/apps/layout/components'
import Tournaments from '@/apps/Tournaments'
import React from 'react'

const TournamentsPage = (): React.ReactElement => {
  return (
    <Layout>
      <Tournaments />
    </Layout>
  )
}

export default TournamentsPage
